import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Badge, Stack, AppBar, Toolbar, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, Button, DialogActions, Typography, ListItem, ListItemIcon, List, ListItemText, Grid, Avatar, Tooltip } from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import Iconify from '../../../components/iconify';
//
import AccountPopover from './AccountPopover';
import { useEffect, useRef, useState } from 'react';
import { getData, putData } from 'src/webService/webService';
import Swal from 'sweetalert2';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  [theme.breakpoints.up('lg')]: {
    // width: `calc(100% - ${NAV_WIDTH + 1}px)`,
    width: "auto",
    zIndex: 1000,
    background: "none",
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
};


export default function Header({ onOpenNav }) {

  const sessionToken = sessionStorage.getItem("Token");
  const role = sessionStorage.getItem("role");
  const serviceTeamType = sessionStorage.getItem("serviceTeamType");
  const userId = sessionStorage.getItem("userId")

  const [open, setOpen] = useState(false);
  const [openPayment, setOpenPayment] = useState(false);
  const [scroll, setScroll] = useState('paper');
  const descriptionElementRef = useRef(null);
  const [limit, setLimit] = useState(10)
  const [allLimit, setAllLimit] = useState(10)
  const [notifications, setNotifications] = useState([]);
  const [paymentNotifications, setPaymentNotifications] = useState([]);
  const [newNotificationCount, setNewNotificationCount] = useState(0);
  const notificationId = sessionStorage.getItem("notificationId");
  const assignedTo = sessionStorage.getItem("assignedTo")
  const leadId = sessionStorage.getItem("leadId");

  const handleClickOpen = (scrollType) => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePaymentOpen = () => {
    setOpenPayment(true);
    setScroll('paper');
  }

  const handlePaymentClose = () => {
    setOpenPayment(false)
  }

  const getAllNotifications = async (limitValue = allLimit) => {
    const params = {
      page: 1,
      limit: limitValue
    }
    try {
      const response = await getData(`notification/notifications/${userId}`, params, sessionToken);
      console.log("Response:", response?.data)
      if (response?.status === 200) {
        sessionStorage.setItem('notificationId', response?.data?._id)
        sessionStorage.setItem('assignedTo', response?.data?.assignedTo)
        sessionStorage.setItem('leadId', response?.data?.leadId)
        const responseData = response?.data?.notifications;
        setNotifications(responseData);

        responseData.forEach(element => {
          if (element.type === "PaymentReminder") {
            Swal.fire({
              title: 'Payment Reminder',
              text: element.message,
              icon: 'info',
              confirmButtonText: 'Ok',
            })
          }
        });

      }
    }
    catch (error) {
      console.error("Error fetching notifications:", error);
    }
  }

  const getAllPaymentNotifications = async (limitValue = limit) => {
    const params = {
      page: 1,
      limit: limitValue
    }
    try {
      const response = await getData(`notification/notification`, params, sessionToken);
      console.log("Response:", response?.data)
      if (response?.status === 200) {
        sessionStorage.setItem('notificationId', response?.data?._id)
        sessionStorage.setItem('assignedTo', response?.data?.assignedTo)
        sessionStorage.setItem('leadId', response?.data?.leadId)
        const responseData = response?.data?.results;

        const latestIds = responseData.map(n => n._id);
        const existingIds = notifications.map(n => n._id);

        const newOnes = latestIds.filter(id => !existingIds.includes(id));
        setNewNotificationCount(newOnes.length);

        setPaymentNotifications(responseData);

        responseData.forEach(element => {
          if (element.type === "PaymentReminder") {
            Swal.fire({
              title: 'Payment Reminder',
              text: element.message,
              icon: 'info',
              confirmButtonText: 'Ok',
            })
          }
        });

      }
    }
    catch (error) {
      console.error("Error fetching notifications:", error);
    }
  }

  const handleLimit = () => {
    const newLimit = limit + 10;
    setLimit(newLimit);
    getAllPaymentNotifications(newLimit);
  };

  const handleAllLimit = () => {
    const allLimit = limit + 10;
    setAllLimit(allLimit);
    getAllNotifications(allLimit);
  };

  useEffect(() => {
    getAllNotifications();
    if (role === "Admin" || serviceTeamType === "Sales") {
      getAllPaymentNotifications();
    }
  }, [userId, sessionToken]);


  const updateAdminApproval = async (adminApproval, id, leadId, assignedTo) => {
    debugger;
    try {
      const params = {
        adminApprovalStatus: adminApproval
      }
      const response = await putData(`leads/lead/${leadId}/status`, params, sessionToken);
      console.log("Response:", response);

      if (response.status === 200) {
        const params = {
          status: 'read'
        }
        const response = await putData(`notification/${id}/${assignedTo}`, params, sessionToken)
        if (response.status === 200) {
          alert("updated")
        }
      }
      const responseData = response?.data?.notifications;
      // setNotifications(responseData);
      getAllNotifications();
      handleClose();

    } catch (error) {
      console.error("Error updating notification:", error);
    }
  };

  return (
    <StyledRoot>
      <StyledToolbar>
        <Badge onClick={handlePaymentOpen} badgeContent={newNotificationCount} color="error">
          <Button variant='outlined'>
            <Typography variant='caption'>
              <Iconify
                icon="solar:bell-bold"
                sx={{ color: "black", cursor: "pointer", margin: "-6px 2px" }}
              />
              Payment Reminder
            </Typography>
          </Button>
        </Badge>
        <Tooltip title="All Notification">
          <Iconify
            icon="material-symbols:sms"
            width="30px"
            sx={{ color: "black", margin: "0px 10px", cursor: "pointer" }}
            onClick={() => { handleClickOpen('paper') }}
          />
        </Tooltip>
        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          <AccountPopover />
        </Stack>
        <Dialog open={open} onClose={handleClose} scroll={scroll} aria-labelledby="scroll-dialog-title" aria-describedby="scroll-dialog-description">
          <DialogTitle id="scroll-dialog-title">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>Notifications</span>
              <Button variant="" style={{ minWidth: 0 }} onClick={handleClose}><Iconify icon="mdi:close" /></Button>
            </div>
          </DialogTitle>
          <DialogContent dividers={scroll === 'paper'}>
            <DialogContentText id="scroll-dialog-description" ref={descriptionElementRef} tabIndex={-1}>
              <List>
                {notifications.map((item, index) => (
                  <ListItem
                    key={item.assignedTo}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 2,
                      paddingY: 2,
                      cursor: "pointer",
                      borderBottom: "1px solid black",
                      borderRadius: 2,
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
                      <Avatar sx={{ marginRight: 2 }} />
                      <ListItemText
                        primary={<Typography variant="body1" fontWeight="bold">{item.type}</Typography>}
                        secondary={
                          <>
                            {item.message} <br />
                            <Typography variant="caption" color="textSecondary">
                              {new Date(item.createdAt).toLocaleString()}
                            </Typography>
                          </>
                        }
                      />
                    </Box>

                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Button
                        size="small"
                        variant="contained"
                        color="success"
                        sx={{ color: "white" }}
                        onClick={() => updateAdminApproval("Approved", item?._id, item?.leadId, item?.assignedTo)}
                      >
                        Approve
                      </Button>

                      <Button
                        size="small"
                        variant="outlined"
                        color="error"
                        onClick={() => updateAdminApproval("Cancelled", item?._id, item?.leadId, item?.assignedTo)}
                      >
                        Reject
                      </Button>
                    </Box>
                  </ListItem>
                ))}

              </List>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button variant="outlined" onClick={handleAllLimit}>
                  Load More
                </Button>
              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
        <Dialog open={openPayment} scroll={scroll} aria-labelledby="scroll-dialog-title" aria-describedby="scroll-dialog-description">
          <DialogTitle id="scroll-dialog-title">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>Payment Notifications</span>
              <Button variant="" style={{ minWidth: 0 }} onClick={handlePaymentClose}><Iconify icon="mdi:close" /></Button>
            </div>
          </DialogTitle>
          <DialogContent dividers={scroll === 'paper'}>
            <DialogContentText id="scroll-dialog-description" ref={descriptionElementRef} tabIndex={-1}>
              <List>
                {paymentNotifications.map((item, index) => (
                  <ListItem
                    key={item._id || index} // safer unique key
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 2,
                      paddingY: 2,
                      cursor: "pointer",
                      borderBottom: "1px solid black",
                      borderRadius: 2,
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
                      <Avatar sx={{ marginRight: 2 }} />
                      <ListItemText
                        primary={<Typography variant="body1" fontWeight="bold">{item.type}</Typography>}
                        secondary={
                          <>
                            {item.message} <br />
                            <Typography variant="caption" color="textSecondary">
                              {new Date(item.createdAt).toLocaleString()}
                            </Typography>
                          </>
                        }
                      />
                    </Box>
                  </ListItem>
                ))}

                {paymentNotifications.length >= limit && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Button variant="outlined" onClick={handleLimit}>
                      Load More
                    </Button>
                  </Box>
                )}

              </List>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </StyledToolbar>
    </StyledRoot>
  );
}
